import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "../shared/Spinner";
import "../../assets/styles/style.css";
import { InputBase } from "@mui/material";
import RiderServices from "../services/externalServices/riderServices";
import { DataGrid } from "@mui/x-data-grid";
import {
  Paper,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  IconButton,
  LinearProgress,
  Stack,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Rating,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  TextareaAutosize,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tab,
  Tabs,
} from "@mui/material";
import { Edit, Delete, CollectionsOutlined } from "@mui/icons-material";
import { Add as AddIcon } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import DriverEarnings from "./earnings/DriverEarnings";
import Skeleton from "@mui/material/Skeleton";
import NotificationServices from "../services/externalServices/notificationServices";
import CruzeTypeServices from "../services/externalServices/cruzeTypeServices";
import VehicleDetails from "./VehicleDetails";
import BankDetails from "./BankDetails";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import BidDetails from "./BidDetails";
import TrackingServices from "../services/externalServices/trackingservices/trackingServices";
import OwnerServices from "../services/externalServices/trackingservices/ownerServices";

function RidersProfile() {
  const { id } = useParams(); // Get the userId from the URL parameter
  // console.log("id",id);
  const [riderDetails, setriderDetails] = useState(null); // State to store user details
  // const [editedRider, setEditedRider] = useState({});
  const [updatedRider, setUpdatedRider] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [ridersTrip, setRidersTrip] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedTrips, setSearchedTrips] = useState([]);
  const [searchOption, setSearchOption] = useState("byTripId"); // Default opti
  const [riderEarnings, setRiderEarnings] = useState([]);
  const [open, setOpen] = useState(false);
  const [completedTrips, setCompletedTrips] = useState();
  const [cancelledTrips, setCancelledTrips] = useState();
  const [tokens, setTokens] = useState([]);
  const [cruzeTypes, setCruzeTypes] = useState([]);
  const [selectedCruzeType, setSelectedCruzeType] = useState(null);
  const [selectedServiceType, setSelectedServiceType] = useState("");
  // const tokens=[]
  const [message, setMessage] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [ownerList, setOwnerList] = useState([]);
  const [selectedOwner,setSelectedOwner]=useState('')

  const [files, setFiles] = useState({
    aadhar: null,
    pan: null,
    license: null,
    rc: null,
  });

  const [tabIndex, setTabIndex] = useState(0);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  // Fetch user details based on userId using useEffect
  useEffect(() => {
    const riderDataString = localStorage.getItem("riders");
    const riderData = JSON.parse(riderDataString);

    // const currentUser = riderData.find((user) => user.id === parseInt(id));
    // setriderDetails(currentUser);
    const fetchData = async () => {
      try {
        // const response = await axios.get(`http://localhost:8080/riders/${id}`);
        const response = await RiderServices.getDriver(`${id}`);
        setriderDetails(response);

        // setEditedRider(response);
        setUpdatedRider(response);
        setTokens(response.fcm_token);
        // tokens.push(response.fcm_token);
        console.log("setriderDetails", response);
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchData();
    countTrips();
    driverEarnings();
    getCruzeType();
    getOwnersList();
  }, []);

  //bankDetails
  const handleDetailsUpdated = (updatedData) => {
    setriderDetails((prev) => ({
      ...prev,
      bankDetails: updatedData.bankDetails,
    }));
  };

  //vehicleDetails
  const handleVehicleDetailsUpdated = (updatedData) => {
    setriderDetails((prevDetails) => ({
      ...prevDetails,
      ...updatedData,
    }));
  };

  const getCruzeType = async () => {
    try {
      // const response = await axios.get(`http://localhost:8080/riders/${id}`);
      const response = await CruzeTypeServices.getCruzeType();
      setCruzeTypes(response);

      // tokens.push(response.fcm_token);
      console.log("setCruzeTypes", response);
    } catch (error) {
      console.error("Error fetching setCruzeTypes:", error);
    }
  };

  const getOwnersList = async () => {
    try {
      const res = await OwnerServices.getAllOwners();
      console.log("ownerList", res);
      setOwnerList(res);
    } catch (error) {
      console.error("error getting ownerlist", error);
    }
  };

  const handleTripSearch = () => {
    countTrips(searchQuery, searchOption);
    setSearchQuery("");
  };

  // const countTrips = async (searchQuery,searchOption) => {
  //   try {
  //     const response = await axios.get(
  //       `http://localhost:8080/rider-trip-counts/${id}`
  //     );

  //     const validTrips = response.data[0].trips.filter((trip) => {
  //       const parsedDate = new Date(trip.trip_start_time);
  //       return !isNaN(parsedDate.getTime()); // Filter out trips with invalid dates
  //     });

  //     // Apply search functionality
  //     const filteredTrips = searchQuery
  //       ? validTrips.filter((trip) =>
  //           trip._id.toLowerCase().includes(searchQuery.toLowerCase())
  //         )
  //       : validTrips;

  //     const sortedTrips = filteredTrips.sort((a, b) => {
  //       const dateA = new Date(a.trip_start_time);
  //       const dateB = new Date(b.trip_start_time);

  //       // Sort in descending order
  //       return dateB.getTime() - dateA.getTime();
  //     });

  //     setSearchedTrips(sortedTrips);
  //     setRidersTrip(sortedTrips);
  //     console.log("tripdates======", sortedTrips);
  //   } catch (err) {
  //     console.log("fetching riders trip failed", err);
  //   }
  // };

  // const countTrips = async (req, res, searchQuery) => {
  //   try {
  //     const response = await axios.get(
  //       `http://localhost:8080/rider-trip-counts/${id}`
  //     );

  //     const validTrips = response.data[0].trips.filter((trip) => {
  //       const parsedDate = new Date(trip.trip_start_time);
  //       return !isNaN(parsedDate.getTime()); // Filter out trips with invalid dates
  //     });

  //     // Apply search functionality
  //     const filteredTrips = searchQuery
  //       ? validTrips.filter((trip) =>
  //           trip._id.toLowerCase().includes(searchQuery.toLowerCase())
  //         )
  //       : validTrips;

  //     const sortedTrips = filteredTrips.sort((a, b) => {
  //       const dateA = new Date(a.trip_start_time);
  //       const dateB = new Date(b.trip_start_time);

  //       // Sort in descending order
  //       return dateB.getTime() - dateA.getTime();
  //     });

  //     setRidersTrip(sortedTrips);
  //     console.log("searchQuery======", searchQuery);
  //   } catch (err) {
  //     console.log("fetching riders trip failed", err);
  //   }
  // };

  const countTrips = async (searchQuery, searchOption) => {
    try {
      // const response = await axios.get(
      //   `http://localhost:8080/rider-trip-counts/${id}`
      // );
      const response = await RiderServices.getDriverTripcount(`${id}`);
      setRidersTrip(response[0].trips);
      console.log("Response in getdriverTripCount", response);

      const completedTrips = response[0].trips.filter(
        (trip) => trip.status === "TRIP_ENDED"
      );
      const cancelledTrips = response[0].trips.filter(
        (trip) => trip.status === "CANCELLED"
      );
      console.log("completedTrips", completedTrips);
      setCompletedTrips(completedTrips.length);
      setCancelledTrips(cancelledTrips.length);
      // console.log("userTripDetails", trips);

      const validTrips = response[0].trips.filter((trip) => {
        const parsedDate = new Date(trip.trip_start_time);
        return !isNaN(parsedDate.getTime()); // Filter out trips with invalid dates
      });

      // Apply search functionality based on the chosen option
      const filteredTrips = searchQuery
        ? validTrips.filter((trip) =>
            searchOption === "byTripId"
              ? trip._id.toLowerCase().includes(searchQuery.toLowerCase())
              : formatDDMMYYYY(trip.trip_start_time).includes(searchQuery)
          )
        : validTrips;

      const sortedTrips = filteredTrips.sort((a, b) => {
        const dateA = new Date(a.trip_start_time);
        const dateB = new Date(b.trip_start_time);

        // Sort in descending order
        return dateB.getTime() - dateA.getTime();
      });

      setSearchedTrips(sortedTrips);
      // setRidersTrip(sortedTrips);
      console.log("tripdates======", sortedTrips);
    } catch (err) {
      console.log("fetching riders trip failed", err);
    }
  };

  //getting the Driver Earnings
  const driverEarnings = async () => {
    // const result = await axios.get(
    //   `http://localhost:8080/rider-earnings/${id}`
    // );
    try {
      const result = await RiderServices.getDriverEarnings(id);
      console.log("driverEarnings", result);
      setRiderEarnings(result);
    } catch (error) {
      console.log("error while getting the driverEarnings", error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    console.log("event.target", event);
    setUpdatedRider((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const handleSave = () => {
    setIsSaving(true);
    console.log("HandleSave buton is clicked", updatedRider);
    console.log(updatedRider);
    console.log(id, "id");
    // axios
    //   .put(`http://localhost:8080/riders/${id}`, updatedRider)
    RiderServices.updateRider(id, updatedRider)
      .then((response) => {
        setSnackbarMessage("User data updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        console.log("User data updated successfully:", response);
        // You can redirect or display a success message here
        // const updatedRiderData = JSON.parse(localStorage.getItem("riders"));
        // console.log("updatedRiderData",updatedRiderData)
        // const updatedRiderDataIndex = updatedRiderData.findIndex(
        //   (rider) => rider.id === parseInt(id)
        // );
        // if (updatedRiderDataIndex !== -1) {
        //   updatedRiderData[updatedRiderDataIndex] = updatedRider;
        //   localStorage.setItem("riders", JSON.stringify(updatedRiderData));
        // }
        // window.location.reload();
      })
      .catch((error) => {
        setSnackbarMessage("Error updating user data.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        console.error("Error updating user data:", error);
        // Display an error message here
      })
      .finally(() => {
        setIsSaving(false); // Set isSaving to false when the request is complete
      });
  };

  // const handleApprove = async (e) => {
  //   e.preventDefault();
  //   let title = "Congratulation";
  //   let body = "Your Application for the Cruze Partner as been approved";
  //   let notificationType = "promotional";
  //   const notificationData = {
  //     tokens,
  //     title,
  //     body,
  //     notificationType,
  //   };

  //   try {
  //     // const response = await axios.post(
  //     //   "http://localhost:8080/sendNotification",
  //     //   {
  //     //     tokens,
  //     //     title,
  //     //     body,
  //     //   }
  //     // );
  //     const RiderResponse = await RiderServices.updateRider(id, {
  //       is_approved: true,
  //     });
  //     setriderDetails(RiderResponse);
  //     console.log("RiderResponse", RiderResponse);
  //     console.log("Notification data", notificationData);
  //     const response =
  //       await NotificationServices.sendNotificationToPendingDriver(
  //         notificationData
  //       );
  //     setMessage("Notification sent successfully!");
  //     console.log("Notification sent successfully!", response);
  //   } catch (error) {
  //     setMessage("Error sending notification.");
  //     console.error(error);
  //   }
  // };

  const handleApprove = async (e) => {
    e.preventDefault();

    let title = "Congratulation";
    let body = "Your Application for the Cruze Partner has been approved";
    let notificationType = "promotional";
    const notificationData = {
      tokens,
      title,
      body,
      notificationType,
    };

    // Ensure that updatedRider includes is_approved = true
    const updatedRiderWithApproval = {
      ...updatedRider, // Spread the existing rider data
      is_approved: true, // Add or update the is_approved field
    };
    // Update rider approval status
    RiderServices.updateRider(id, updatedRiderWithApproval)
      .then((RiderResponse) => {
        // Check if the rider was successfully updated to approved
        console.log("updatedRider===========", updatedRider);
        if (RiderResponse.is_approved) {
          console.log("Rider approved successfully:", RiderResponse);
          setriderDetails(RiderResponse);
          setSnackbarMessage("Rider approved successfully!");
          setSnackbarSeverity("success");
          setOpenSnackbar(true);

          // Send notification after approval
          // return NotificationServices.sendNotificationToPendingDriver(
          //   notificationData
          // );
        } else {
          throw new Error("Failed to update rider approval.");
        }
      })
      .then((response) => {
        // Handle successful notification
        setSnackbarMessage("Notification sent successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        console.log("Notification sent successfully!", response);
        setMessage("Notification sent successfully!");
      })
      .catch((error) => {
        // Handle errors in approval or notification
        setSnackbarMessage("Error approving rider or sending notification.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);

        console.error("Error in approval or notification:", error);
        setMessage("Error sending notification.");
      });
  };

  const handleRevokeApproval = async (e) => {
    try {
      // const response = await axios.post(
      //   "http://localhost:8080/sendNotification",
      //   {
      //     tokens,
      //     title,
      //     body,
      //   }
      // );
      const RiderResponse = await RiderServices.updateRider(id, {
        is_approved: false,
      });
      console.log("RiderResponse", RiderResponse);
      // console.log("Notification data", notificationData);
      // const response=await NotificationServices.sendNotificationToPendingDriver(notificationData)
      setriderDetails(RiderResponse);
      // console.log("Notification sent successfully!", response);
    } catch (error) {
      setMessage("Error sending notification.");
      console.error(error);
    }
  };

  const formatDDMMYYYY = (date) => {
    // const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
    const options = {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const formattedDate = new Date(date);
    return formattedDate.toLocaleString("en-GB", options);
  };

  //adding the Driver Documents

  const handleFileChange = (event, fileType) => {
    setFiles({
      ...files,
      [fileType]: event.target.files[0],
    });
  };

  const saveDriverDocuments = async () => {
    try {
      const formData = new FormData();
      Object.entries(files).forEach(([key, value]) => {
        if (value) {
          // Check if file is selected
          console.log("values", value);
          formData.append(key, value);
        } else {
          console.log("value is not defined");
        }
      });

      // Make a POST request to your server endpoint with Axios
      const response = await axios.post(
        "http://localhost:8080/uploadDriverFiles",
        formData
      );

      // Handle the response
      console.log(response.data);
      alert("Files uploaded successfully.");
    } catch (error) {
      console.error("Error saving files:", error);
      // alert("Error uploading files. Please try again later.");
    }
  };

  const columns = [
    { field: "amount", headerName: "Amount", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        let label, color;

        switch (params.value) {
          case "TRIP_ENDED":
            label = "Completed";
            color = "success";
            break;
          case "CANCELLED":
            label = "Cancelled";
            color = "error";
            break;
          case "TRIP_STARTED":
            label = "In Progress";
            color = "info";
            break;
          case "ON_THE_WAY":
            label = "On the Way";
            color = "primary";
            break;
          default:
            label = "Pending";
            color = "warning";
            break;
        }

        return <Chip label={label} color={color} variant="soft" size="small" />;
      },
    },
    {
      field: "tripid",
      headerName: "TripID",
      flex: 1,
      renderCell: (params) => {
        const tripId = params.value;
        return <Link to={`/trip/${tripId}`}>{tripId}</Link>;
      },
    },
    {
      field: "trip_start_time",
      headerName: "Date",
      flex: 1,
      // valueGetter: (params) => formatDate(params.value),
    },
  ];
  const tripsToMap = searchedTrips.length > 0 ? searchedTrips : ridersTrip;
  // console.log("tripsToMap======",tripsToMap)
  const rows = tripsToMap.map((trip, index) => ({
    id: index, // Unique row ID
    amount: trip.bid ? `${trip.bid.amount}` : "N/A",
    status: trip.status,
    tripid: trip._id,
    trip_start_time: trip.trip_start_time,
  }));

  //function to showing the document details

  const handleUrlClick = (url) => {
    window.open(url, "_blank");
  };
  const handleTabChange = (event, newValue) => {
    console.log("index", newValue);
    setTabIndex(newValue);
  };

  return (
    <Paper>
      {riderDetails && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Link
                  to="/riders"
                  underline="hover"
                  variant="subtitle2"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5em"
                    height="1.5em"
                    fill="currentColor"
                    viewBox="0 0 256 256"
                    fontSize="var(--icon-fontSize-md)"
                  >
                    <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                  </svg>
                </Link>
              </Grid>
              <Grid item>
                <Link
                  to="/riders"
                  underline="hover"
                  variant="subtitle2"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Typography variant="subtitle2">Riders</Typography>
                </Link>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Avatar
                  src={riderDetails.avatar_url}
                  sx={{ width: 70, height: 70 }}
                />
              </Grid>
              <Grid item>
                <Typography variant="h4">
                  {riderDetails.first_name} {riderDetails.last_name}
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Chip
                    label={riderDetails.is_online ? "Online" : "Offline"}
                    color={riderDetails.is_online ? "success" : "error"}
                    variant="outlined"
                    size="small"
                  />
                  <Chip
                    label={riderDetails.is_approved ? "Approved" : "Pending"}
                    color={riderDetails.is_approved ? "success" : "error"}
                    variant="outlined"
                    size="small"
                  />
                  <Chip
                    label={
                      riderDetails.isOccupied
                        ? "Occupied"
                        : "Ready To Get CabRequest"
                    }
                    color={riderDetails.isOccupied ? "error" : "success"}
                    variant="outlined"
                    size="small"
                  />
                </Stack>

                <Typography variant="body1" color="#667085">
                  {riderDetails.email_id}
                </Typography>
                {/* <Chip
                    label={
                      riderDetails.phone_number
                        ? riderDetails.phone_number
                        : "N/A"
                    }
                    color={riderDetails.phone_number ? "success" : "error"}
                    variant="outlined"
                    size="small"
                  /> */}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center", // Centers horizontally
              alignItems: "center", // Centers vertically
              height: "100%", // Optional: Ensures alignment within parent container
            }}
          >
            <Tabs value={tabIndex} onChange={handleTabChange} centered>
              <Tab label="Trips" />
              <Tab label="Earnings" />
              <Tab label="Vehicle Details" />
              <Tab label="Profile" />
              <Tab label="Bank Details" />
              <Tab label="Upcoming Trips" />
              <Tab label="Bids" />
            </Tabs>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "16px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                {tabIndex === 3 && (
                  <Card elevation={2} sx={{ borderRadius: "16px" }}>
                    <CardHeader
                      avatar={
                        <Paper
                          elevation={3}
                          style={{
                            backgroundColor: "white",
                            width: 50,
                            height: 50,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Avatar style={{ backgroundColor: "white" }}>
                            {/* <GroupIcon fontSize="large" /> */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="1em"
                              height="1em"
                              fill="black"
                              viewBox="0 0 256 256"
                              font-size="var(--icon-fontSize-lg)"
                            >
                              <path d="M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z"></path>
                            </svg>
                            {/* <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10.1992 12C12.9606 12 15.1992 9.76142 15.1992 7C15.1992 4.23858 12.9606 2 10.1992 2C7.43779 2 5.19922 4.23858 5.19922 7C5.19922 9.76142 7.43779 12 10.1992 12Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M1 22C1.57038 20.0332 2.74795 18.2971 4.36438 17.0399C5.98081 15.7827 7.95335 15.0687 10 15C14.12 15 17.63 17.91 19 22" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.8205 4.44006C18.5822 4.83059 19.1986 5.45518 19.579 6.22205C19.9594 6.98891 20.0838 7.85753 19.9338 8.70032C19.7838 9.5431 19.3674 10.3155 18.7458 10.9041C18.1243 11.4926 17.3302 11.8662 16.4805 11.97" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.3203 14.5701C18.6543 14.91 19.8779 15.5883 20.8729 16.5396C21.868 17.4908 22.6007 18.6827 23.0003 20" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg> */}
                          </Avatar>
                        </Paper>
                      }
                      action={
                        <IconButton onClick={handleClickOpen}>
                          <Edit />
                        </IconButton>
                      }
                      title={
                        <Typography variant="h6" color="#667085">
                          Basic details
                        </Typography>
                      }
                    />
                    <CardContent>
                      {/* Card Content */}
                      <Box mb={2}>
                        <Typography variant="body2" color="#667085">
                          Rider ID
                        </Typography>
                        <Chip
                          label={riderDetails._id}
                          style={{ backgroundColor: "#f0f4f8", color: "#000" }}
                          size="small"
                        />
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Name
                        </Typography>
                        <Typography variant="subtitle2">
                          {riderDetails.first_name} {riderDetails.last_name}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Email
                        </Typography>
                        <Typography variant="subtitle2">
                          {riderDetails.email_id}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Phone
                        </Typography>
                        <Typography variant="subtitle2">
                          {riderDetails.phone_number}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Vehicle
                        </Typography>
                        <Typography variant="subtitle2">
                          {riderDetails.vehicle_name}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Vehicle Number
                        </Typography>
                        <Typography variant="subtitle2">
                          {/* {riderDetails.emergency_contact} */}
                          {riderDetails.vehicle_number}
                        </Typography>
                      </Box>
                      <Divider />

                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Aadhar
                        </Typography>
                        <Button
                          onClick={() => handleUrlClick(riderDetails.adhar_url)}
                          style={{ padding: 0, textTransform: "none" }}
                        >
                          <Typography variant="subtitle2" color="primary">
                            {riderDetails.adhar_url}
                          </Typography>
                        </Button>
                      </Box>

                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Licence
                        </Typography>
                        <Button
                          onClick={() => handleUrlClick(riderDetails.adhar_url)}
                          style={{ padding: 0, textTransform: "none" }}
                        >
                          <Typography variant="subtitle2" color="primary">
                            {riderDetails.license_url}
                          </Typography>
                        </Button>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Registration
                        </Typography>
                        <Button
                          onClick={() => handleUrlClick(riderDetails.adhar_url)}
                          style={{ padding: 0, textTransform: "none" }}
                        >
                          <Typography variant="subtitle2" color="primary">
                            {riderDetails.registration_url}
                          </Typography>
                        </Button>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          PAN
                        </Typography>
                        <Button
                          onClick={() => handleUrlClick(riderDetails.adhar_url)}
                          style={{ padding: 0, textTransform: "none" }}
                        >
                          <Typography variant="subtitle2" color="primary">
                            {riderDetails.pan_url}
                          </Typography>
                        </Button>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Rating
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Rating
                            name="read-only"
                            value={riderDetails.rating}
                            precision={0.5}
                          />
                          <Typography variant="body2">{`${
                            riderDetails.rating * 20
                          }%`}</Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Vehicle Type
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Typography variant="body2">
                            {riderDetails.vehicleType}
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Service Associated
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Typography variant="body2">
                            {riderDetails.serviceAssociated}
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Cruze Type
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Typography variant="body2">
                            {riderDetails.cruzeId?.cruzeName}
                          </Typography>
                        </Stack>
                      </Box>
                    </CardContent>
                  </Card>
                )}

                <Dialog open={open} onClose={handleClose} fullWidth>
                  <DialogTitle>
                    Edit Details
                    <IconButton
                      aria-label="close"
                      onClick={handleClose}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent style={{ marginTop: "4px" }}>
                    <form>
                      <Grid container spacing={2} mb={3}></Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            ID
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="id"
                            variant="outlined"
                            value={riderDetails._id || ""}
                            disabled
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Firstname
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="first_name"
                            variant="outlined"
                            defaultValue={riderDetails.first_name || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Lastname
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="last_name"
                            variant="outlined"
                            defaultValue={riderDetails.last_name || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Phone Number
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="phone_number"
                            variant="outlined"
                            defaultValue={riderDetails.phone_number || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Password
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="password"
                            variant="outlined"
                            defaultValue={riderDetails.password || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Email ID
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="email_id"
                            variant="outlined"
                            defaultValue={riderDetails.email_id || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Avatar URL
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="avatar_url"
                            variant="outlined"
                            defaultValue={riderDetails.avatar_url || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Registration URL
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="registration_url"
                            variant="outlined"
                            defaultValue={riderDetails.registration_url || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Licence URL
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="licence_url"
                            variant="outlined"
                            defaultValue={riderDetails.licence_url || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Pan URL
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="pan_url"
                            variant="outlined"
                            defaultValue={riderDetails.pan_url || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Aadhaar URL
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="adhar_url"
                            variant="outlined"
                            defaultValue={riderDetails.adhar_url || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      {/* <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Vehicle Name
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="vehicle_name"
                            variant="outlined"
                            defaultValue={riderDetails.vehicle_name || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Vehicle Number
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="vehicle_number"
                            variant="outlined"
                            defaultValue={riderDetails.vehicle_number || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid> */}

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Vehicle Type
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            fullWidth
                            name="vehicleType"
                            variant="outlined"
                            defaultValue={riderDetails.vehicleType || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Associated With
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="service-associated-label">
                              Associated With
                            </InputLabel>
                            <Select
                              labelId="service-associated-label"
                              name="serviceAssociated"
                              value={
                                selectedServiceType ||
                                riderDetails.serviceAssociated
                              }
                              onChange={(event) => {
                                setSelectedServiceType(event.target.value);
                                handleInputChange(event);
                              }}
                              // label="Associated With"
                            >
                              <MenuItem value="TourPackage">
                                TourPackage
                              </MenuItem>
                              <MenuItem value="Tracking">Tracking</MenuItem>
                              <MenuItem value="Auto">Auto</MenuItem>
                              {/* Add more options as needed */}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Assigned Tracking Owner
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="owner-select-label">
                              Select Owner
                            </InputLabel>
                            <Select
                              labelId="owner-select-label"
                              name="assigned_owner_id"
                              value={
                                selectedOwner|| riderDetails.assigned_owner_id || ""
                              }
                              onChange={(event) => {
                                setSelectedOwner(event.target.value);
                                handleInputChange({
                                  target: {
                                    name: "assigned_owner_id",
                                    value: event.target.value, // store only _id
                                  },
                                });
                              }}
                            >
                              {ownerList.map((owner) => (
                                <MenuItem key={owner._id} value={owner._id}>
                                  {owner.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            Cruze Type
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="cruze-type-label">
                              Select Cruze Type
                            </InputLabel>
                            <Select
                              labelId="cruze-type-label"
                              name="cruzeId"
                              value={
                                selectedCruzeType ||
                                riderDetails.cruzeId?._id ||
                                ""
                              }
                              onChange={(event) => {
                                setSelectedCruzeType(event.target.value); // Update local state
                                handleInputChange({
                                  target: {
                                    name: "cruzeId",
                                    value: event.target.value,
                                  }, // Update parent state
                                });
                              }}
                              label="Select Cruze Type"
                            >
                              {cruzeTypes.map((type) => (
                                <MenuItem key={type._id} value={type._id}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={8}>
                                      <Typography variant="body2">
                                        {type.cruzeName || "Unnamed Cruze"}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        color="textSecondary"
                                      >
                                        Seating Capacity: {type.seatingCapacity}{" "}
                                        + 1
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={4}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {type.thumbnailImage ? (
                                        <img
                                          src={type.thumbnailImage}
                                          alt={type.cruzeName}
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            objectFit: "cover",
                                          }}
                                        />
                                      ) : (
                                        <div
                                          style={{
                                            width: "50px",
                                            height: "50px",
                                            backgroundColor: "#ccc",
                                          }}
                                        />
                                      )}
                                    </Grid>
                                  </Grid>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Snackbar
                          open={openSnackbar}
                          autoHideDuration={3000} // 3 seconds
                          onClose={handleSnackbarClose}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <Alert
                            onClose={handleSnackbarClose}
                            severity={snackbarSeverity}
                            sx={{ width: "100%" }}
                          >
                            {snackbarMessage}
                          </Alert>
                        </Snackbar>
                      </Grid>

                      <Divider />

                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid item xs={12} md={3}>
                          <Box mt={2} textAlign="center">
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleSave}
                              disabled={isSaving}
                            >
                              {isSaving ? (
                                <CircularProgress size={24} />
                              ) : (
                                "Save Changes"
                              )}
                            </Button>
                          </Box>
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <Box mt={2} textAlign="center">
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={
                                riderDetails.is_approved
                                  ? handleRevokeApproval
                                  : handleApprove
                              } // Change handler based on approval status
                              disabled={isSaving}
                            >
                              {
                                isSaving ? (
                                  <CircularProgress size={24} />
                                ) : riderDetails.is_approved ? (
                                  "Revoke Approval"
                                ) : (
                                  "Approve"
                                ) // Conditional text rendering
                              }
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </form>
                  </DialogContent>
                </Dialog>
                {/* </Grid> */}
                {/* <Grid  item xs={12}> */}
                {tabIndex === 7 && (
                  <Card
                    elevation={2}
                    style={{ borderRadius: "16px", marginTop: "8px" }}
                  >
                    <CardContent>
                      {/* Card Content */}
                      <Stack spacing={2}>
                        <Button
                          variant="contained"
                          color="error"
                          startIcon={<Delete />}
                        >
                          Delete account
                        </Button>
                        <Typography variant="body2">
                          A deleted customer cannot be restored. All data will
                          be permanently removed.
                        </Typography>
                      </Stack>
                    </CardContent>
                  </Card>
                )}
              </Grid>
              {tabIndex === 5 && (
                <Grid item xs={12} md={12}>
                  <Card elevation={2} sx={{ borderRadius: "16px" }}>
                    <CardHeader
                      avatar={
                        <Paper
                          elevation={3}
                          style={{
                            backgroundColor: "white",
                            width: 50,
                            height: 50,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Avatar style={{ backgroundColor: "white" }}>
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {/* SVG Content */}
                              <path
                                d="M8.57385 20.3523L11.9553 13.5894C11.9737 13.5526 12.0263 13.5526 12.0447 13.5894L15.4261 20.3523C15.4483 20.3965 15.3996 20.4426 15.3566 20.4181L12.0248 18.5142C12.0094 18.5054 11.9906 18.5054 11.9752 18.5142L8.64338 20.4181C8.60043 20.4426 8.55173 20.3965 8.57385 20.3523Z"
                                stroke="#33363F"
                                stroke-linecap="round"
                              ></path>
                            </svg>
                          </Avatar>
                        </Paper>
                      }
                      title={
                        <Typography variant="h6" color="#667085">
                          Upcoming Trips
                        </Typography>
                      }
                    />
                    {riderDetails.bookedDates?.length >= 1 ? (
                      <CardContent>
                        <Stack
                          direction="column"
                          spacing={2}
                          justifyContent="space-between"
                        >
                          <Paper variant="outlined" sx={{ padding: 2 }}>
                            <Stack
                              direction="row"
                              spacing={2}
                              justifyContent="space-between"
                            >
                              <div>
                                <Typography variant="overline" color="#667085">
                                  Total Upcoming Trips
                                </Typography>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography variant="h6">
                                    {riderDetails.bookedDates.length}
                                  </Typography>
                                </div>
                              </div>
                            </Stack>
                          </Paper>
                          <Paper
                            variant="outlined"
                            sx={{ padding: 2, flexGrow: 1 }}
                          >
                            <div style={{ height: 400, width: "100%" }}>
                              <DataGrid
                                rows={riderDetails.bookedDates.map(
                                  (trip, index) => ({
                                    id: index,
                                    packageName: trip.packageName,
                                    date: new Date(
                                      trip.selectedDate
                                    ).toLocaleDateString(),
                                    time: new Date(
                                      trip.selectedTime
                                    ).toLocaleTimeString(),
                                    tripId: trip.tripId,
                                  })
                                )}
                                columns={[
                                  {
                                    field: "packageName",
                                    headerName: "Package Name",
                                    flex: 1,
                                  },
                                  {
                                    field: "date",
                                    headerName: "Date",
                                    flex: 1,
                                  },
                                  {
                                    field: "time",
                                    headerName: "Time",
                                    flex: 1,
                                  },
                                  {
                                    field: "tripId",
                                    headerName: "Trip ID",
                                    flex: 1,
                                  },
                                ]}
                                pageSize={5}
                                rowsPerPageOptions={[5]}
                              />
                            </div>
                          </Paper>
                        </Stack>
                      </CardContent>
                    ) : (
                      <CardContent>
                        <Stack
                          direction="column"
                          spacing={2}
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography variant="h6" color="textSecondary">
                            No upcoming trips available
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            You currently have no scheduled trips to display.
                          </Typography>
                        </Stack>
                      </CardContent>
                    )}
                  </Card>
                </Grid>
              )}

              {tabIndex === 0 && (
                <Grid item xs={12} md={12}>
                  <Card elevation={2} sx={{ borderRadius: "16px" }}>
                    <CardHeader
                      avatar={
                        <Paper
                          elevation={3}
                          style={{
                            backgroundColor: "white",
                            width: 50,
                            height: 50,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Avatar style={{ backgroundColor: "white" }}>
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                {" "}
                                <path
                                  d="M8.57385 20.3523L11.9553 13.5894C11.9737 13.5526 12.0263 13.5526 12.0447 13.5894L15.4261 20.3523C15.4483 20.3965 15.3996 20.4426 15.3566 20.4181L12.0248 18.5142C12.0094 18.5054 11.9906 18.5054 11.9752 18.5142L8.64338 20.4181C8.60043 20.4426 8.55173 20.3965 8.57385 20.3523Z"
                                  stroke="#33363F"
                                  stroke-linecap="round"
                                ></path>{" "}
                                <path
                                  d="M20.5 18.5L16.5 3.5"
                                  stroke="#33363F"
                                  stroke-linecap="round"
                                ></path>{" "}
                                <path
                                  d="M3.5 18.5L7.5 3.5"
                                  stroke="#33363F"
                                  stroke-linecap="round"
                                ></path>{" "}
                                <path
                                  d="M12 10.5V8.5"
                                  stroke="#33363F"
                                  stroke-linecap="round"
                                ></path>{" "}
                                <path
                                  d="M12 5.5V3.5"
                                  stroke="#33363F"
                                  stroke-linecap="round"
                                ></path>{" "}
                              </g>
                            </svg>
                          </Avatar>
                        </Paper>
                      }
                      title={
                        <Typography variant="h6" color="#667085">
                          Trips
                        </Typography>
                      }
                      action={
                        <div className="input-group pt-1">
                          <select
                            className="form-select"
                            value={searchOption}
                            onChange={(e) => setSearchOption(e.target.value)}
                          >
                            <option value="byTripId">Trip ID</option>
                            {/* <option value="Date">Date</option> */}
                          </select>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={`Search by ${
                              searchOption === "byTripId" ? "Trip ID" : "Date"
                            }`}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                          <button
                            className="btn btn-outline-primary example"
                            type="button"
                            onClick={handleTripSearch}
                          >
                            Search
                          </button>
                        </div>
                      }
                    />
                    {ridersTrip.length >= 1 ? (
                      <CardContent>
                        <Stack
                          direction="column"
                          spacing={2}
                          justifyContent="space-between"
                        >
                          <Paper variant="outlined" sx={{ padding: 2 }}>
                            <Stack
                              direction="row"
                              spacing={2}
                              justifyContent="space-between"
                            >
                              <div>
                                <Typography variant="overline" color="#667085">
                                  Total trips
                                </Typography>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography variant="h6">
                                    {ridersTrip.length}
                                  </Typography>
                                </div>
                              </div>
                              <Divider orientation="vertical" flexItem />
                              <div>
                                <Typography variant="overline" color="#667085">
                                  Completed Trips
                                </Typography>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography variant="h6">
                                    {completedTrips}
                                  </Typography>
                                </div>
                              </div>
                              <Divider orientation="vertical" flexItem />
                              <div>
                                <Typography variant="overline" color="#667085">
                                  Cancelled Trips
                                </Typography>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography variant="h6">
                                    {cancelledTrips}
                                  </Typography>
                                </div>
                              </div>
                            </Stack>
                          </Paper>
                          <Paper
                            variant="outlined"
                            sx={{ padding: 2, flexGrow: 1 }}
                          >
                            <div style={{ height: 400, width: "100%" }}>
                              <DataGrid
                                rows={rows}
                                columns={columns}
                                pageSize={5}
                                rowsPerPageOptions={[5]}
                              />
                            </div>
                          </Paper>
                        </Stack>
                      </CardContent>
                    ) : (
                      <CardContent>
                        <Stack
                          direction="column"
                          spacing={2}
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography variant="h6" color="textSecondary">
                            No trips available
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            You currently have no trip history to display.
                          </Typography>
                        </Stack>
                      </CardContent>
                    )}
                  </Card>
                </Grid>
              )}

              {tabIndex === 1 && (
                <Grid item xs={12} md={12}>
                  <DriverEarnings earnings={riderEarnings} />
                </Grid>
              )}

              {tabIndex === 2 && (
                <Grid item xs={12} md={12}>
                  <VehicleDetails
                    riderDetails={riderDetails}
                    onDetailsUpdated={handleVehicleDetailsUpdated}
                  />
                </Grid>
              )}

              {tabIndex === 4 && (
                <Grid item xs={12} md={12}>
                  <BankDetails
                    riderDetails={riderDetails}
                    onDetailsUpdated={handleDetailsUpdated}
                  />
                </Grid>
              )}

              {tabIndex === 6 && (
                <Grid item xs={12} md={12}>
                  <BidDetails riderId={id} />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
    </Paper>
  );
}

export default RidersProfile;
